module.exports = __webpack_public_path__ + "static/img/bdc-kpi-income.106df963.svg";